import Vue from "vue";
import API from "app/axios";
import store from "./store";
import router from "./router";

/**
 *  Ascii
 *  https://patorjk.com/software/taag/#p=display&h=2&v=3&c=c%2B%2B&w=%20&f=ANSI%20Regular&t=Topic
 */

const uxEngine = new Vue({
  router,
  store,

  data: function () {
    return {
      tLastActive: 0,
    };
  },

  computed: {},

  methods: {
    performUXReset() {
      // do we want to give the reader a way back?
      let oPayload = {
        url: this.$route.path,
        title: document.title,
      };

      API.getStackShelves();

      if (oPayload.url == "/") {
        // reload data, nothing else
        this.notice("UX Reset (Simple):", oPayload);
        return;
      }

      this.notice("UX Reset:", oPayload);
      this.$router.push(`/`);
      setTimeout(() => {
        this.EventBus.$emit("api:build-check", {});
      }, 300);
      setTimeout(() => {
        // this.notice('UX Reset: emit -- tab:continue');
        this.EventBus.$emit("tab:continue", oPayload);
      }, 1300); // hack: after route has run..
    },

    deviceIsActive() {
      let t = new Date().getTime();
      let o = Math.round((t - this.tLastActive) / 1000);
      let m = 60 * 10; // 10 minutes

      if (o > m) {
        this.performUXReset();
      }
      
      let iLogTime = Math.floor(o * 60); // to the nearest minutes
      let sLogTime = 'Unknown';
      let sBootGrade = 'return';

      if (o <= m) {
        sLogTime =  `≤10m`;
        sBootGrade = 'recent'; 
      } else if (iLogTime <= 60) {
        sLogTime = `≤1h`;
        sBootGrade = 'recent';
      } else if (iLogTime <= (60 * 6)) {
        sLogTime = `≤6h`;
        sBootGrade = 'today';
      } else if (iLogTime <= (60 * 12)) {
        sLogTime = `≤12h`;
        sBootGrade = 'today';
      } else if (iLogTime <= (60 * 24)) {
        sLogTime = `≤1d`;
        sBootGrade = 'today';
      } else if (iLogTime <= (60 * 24 * 3)) {
        sLogTime = `≤3d`;
        sBootGrade = 'return';
      } else if (iLogTime <= (60 * 24 * 7)) {
        sLogTime = `≤3d`;
        sBootGrade = 'return';
      } else {
        sLogTime = `≥1w`;
        sBootGrade = 'return';
      }

      // what if we were *never* active?
      if (!this.tLastActive) {
        sLogTime = 'Boot';
        iLogTime = 0;
      }

      this.notice(`Device: Active! (${sLogTime} : ${iLogTime} : ${o} ~ ${m} : ${this.tLastActive})`);
      
      // this might run very early.. so bounce a millisecond
      setTimeout(() => {
        setTimeout(() => {
          this.EventBus.$emit('track:event', {
            event: 'nourish-app-open',
            props: {
              time: sLogTime,
            },
            detail: {
              detail_val: iLogTime,
              detail_char: sLogTime,
            },
          });
        }, 500); // plausible has some trouble if we're too quick?
        
        this.EventBus.$emit("deviceLog", `isActive: offset :${o}, max :${m} (t :${t}, last :${this.tLastActive})`);
        // do things that you want to re-do every boot (like balancing device models)
        if (sLogTime == 'Boot') {
          // this.notice(`Device: BOOT -- (Signal, usually to rebalance device stats..)`);
          setTimeout(() => {
            this.EventBus.$emit('device:boot', {});
          }, 1000);
        } else {
          this.notice(`Device: Weird? ${sLogTime}`);
        }

        // trigger an event with slightly different flavours for 
        //    - `open:recent` (really recently)
        //    - `open:today` (has opened today, at some point)
        //    - `open:return` (has not been here for a day or two)
        if (sBootGrade) {
          // console.log(`Device: defer device-open calls till account load [${sBootGrade}]`);
          this.EventBus.$on("api:account", (account) => {
            if (!account?.to?.token) {
              // console.log(`Device: Ignore device-open on guest return [${sBootGrade}], `, account);
              return;
            }
            if (this.$userEngine.getPref("_n2")) {
              this.EventBus.$emit(`device:open:once`, sBootGrade);
            } else {
              // console.log(`Device: Trigger HALT! (Either not N2 or settings haven't loaded) [${sBootGrade}]`);
              this.EventBus.$on('user:prefs', () => {
                if (this.$userEngine.getPref("_n2")) {
                  // console.log(`Device: Trigger (Ignore (not N2/loaded)) [${sBootGrade}]`);
                  return;
                }
                // console.log(`Device: Trigger (Maybe/Once) [${sBootGrade}]`);
                this.EventBus.$emit(`device:open:once`, sBootGrade);
              });
            }
          });

          // a "once ONLY" barrier... but only once we're properly logged in!
          this.EventBus.$once("device:open:once", (sBootGrade) => {
            // console.log(`Device: Trigger device-open on user return [${sBootGrade}]`);
            this.EventBus.$emit(`device:open:${sBootGrade}`, {});
          });
        }
      }, 100);

      // obs update last active right away..
      this.updateLastActive();
    },

    updateLastActive() {
      this.tLastActive = new Date().getTime();
    },





    debug() {},

    notice() {
      // console.log(`\x1b[36muxEngine --`, ...arguments);
    },

    error() {
      // console.log(`\x1b[36muxEngine --`, ...arguments);
    },
  },

  created() {
    this.notice("Up and running... ");
    
    // also, the first time we boot... let's activate
    this.EventBus.$emit("xp:sparkle");
    this.deviceIsActive();

    window.setTimeout(() => {
      this.updateLastActive();
      // this.performUXReset(); << -- JSON On for DEBUGGING ONLY! :o)
    }, 1000); // offset after render is up and running

    // keep the last active up to date...
    window.setInterval(() => {
      this.updateLastActive();
    }, 1000 * 60); // every minute

    // keep the shelves up to date...
    window.setInterval(() => {
      API.getStackShelves();
    }, 1000 * 60 * 3); // every three minutes...

    // listend for the device activating..
    this.EventBus.$on("ux:deviceIsActive", () => {
      this.EventBus.$emit("xp:sparkle");
      this.deviceIsActive();
    });

    this.EventBus.$on("ux:setDOMMeta", (meta) => {
      if (meta?.title) {
        document.title = meta.title;
      }
    });
    
  },

  watch: {},
});

Object.defineProperties(Vue.prototype, {
  $uxEngine: {
    get: function () {
      return uxEngine;
    },
  },
});
